import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import { T } from '../../../../../Translations';
import { UpsellResource } from '../../Types';
import UpsellIcon from './UpsellIcon';
import { when } from '@execonline-inc/maybe-adapter';
import { equals, first, last, take } from '@execonline-inc/collections';
import { just } from 'maybeasy';
import { always } from '@kofno/piper';

interface Props {
  upsells: NonEmptyList<UpsellResource>;
}

const upsellTitle = (upsellResource: UpsellResource) => upsellResource.payload.title;

const handleMultipleUpsells = (upsells: NonEmptyList<UpsellResource>) => {
  const commaSeparatedUpsells = just(upsells.toArray()).map(take(upsells.length - 1));
  const lastUpsell = last(upsells.toArray()).map(upsellTitle);

  return just({})
    .assign('commaSeparatedUpsells', commaSeparatedUpsells)
    .assign('lastUpsell', lastUpsell)
    .map(
      ({ commaSeparatedUpsells, lastUpsell }) =>
        `${commaSeparatedUpsells.map(upsellTitle).join(', ')} and ${lastUpsell}`,
    )
    .getOrElseValue('');
};

const handleSingleUpsell = (upsells: NonEmptyList<UpsellResource>) =>
  when(equals(1, upsells.length), upsells.toArray()).andThen(first).map(upsellTitle);

const name = (upsells: NonEmptyList<UpsellResource>) =>
  handleSingleUpsell(upsells).getOrElse(always(handleMultipleUpsells(upsells)));

function Upsell({ upsells }: Props) {
  return (
    <div className="mb-2 rounded-md bg-white px-6 py-4 drop-shadow-md last:mb-0 relative flex items-center">
      <UpsellIcon />
      <div className="pl-6">
        <T
          kind="Expand the developmental experience for your organization with <span>{{name}}</span>..."
          span={(content) => <span className="font-bold">{content}</span>}
          name={name(upsells)}
        />
      </div>
    </div>
  );
}

export default observer(Upsell);
